import * as React from "react";
import * as Dialog from "@radix-ui/react-dialog";

/**
 * Props for ModalCloseWrapper component.
 */
export interface ModalCloseWrapperProps {
  /** The element to wrap with close functionality */
  children: React.ReactNode;
  /** Optional click handler called before closing the modal */
  onClick?: (e: React.MouseEvent) => void;
  /** Whether to merge props into the child element (default: true) */
  asChild?: boolean;
}

/**
 * A wrapper component that closes the modal when its child is clicked.
 * Uses asChild pattern like Radix primitives - by default asChild is true.
 */
export const ModalCloseWrapper = (props: ModalCloseWrapperProps) => {
  const { children, onClick, asChild = true, ...rest } = props;

  const handleClick = (e: React.MouseEvent) => {
    onClick?.(e);
    // Dialog.Close automatically handles closing
  };

  return (
    <Dialog.Close asChild={asChild} onClick={handleClick} {...rest}>
      {React.isValidElement(children)
        ? React.cloneElement(children as React.ReactElement<any>, {
            "data-slot": "modal-close-wrapper",
            "data-qa-modal-close-wrapper": "",
            ...((children as React.ReactElement<any>).props || {}),
          })
        : children}
    </Dialog.Close>
  );
};

ModalCloseWrapper.displayName = "ModalCloseWrapper";
